import { LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import * as TagNames from './nav-tabs.tagnames';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { AtlPageTabClickEvent } from './nav-tabs.events';
import { AtlPageTabProps, PageTab } from './nav-tabs.props';

@customElement(TagNames.PageTabs)
export class AtlPageTabs extends LitElement implements AtlPageTabProps {
   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   static properties = {
      tabs: { type: Array },
   };

   declare tabs?: PageTab[];

   private _renderTabs = () => {
      if (!this.tabs) return nothing;

      return this.tabs?.map((tabPane, idx) => {
         const classNames = {
            'nav-link': true,
            active: tabPane.active === true,
         };
         return html`<li class="nav-item" aria-label=${ifDefined(tabPane.name)}>
            <button
               type="button"
               class=${classMap(classNames)}
               tabindex="0"
               @click=${() =>
                  this.dispatchEvent(new AtlPageTabClickEvent(idx, tabPane))}
            >
               ${tabPane.label}
            </button>
         </li>`;
      });
   };

   render() {
      return html`
         <div class="tabs-container">
            <ul class="flex-nowrap nav nav-tabs tabs-mainheader">
               ${this._renderTabs()}
            </ul>

            <div class="tab-content">
               <slot></slot>
            </div>
         </div>
      `;
   }
}
